import { render, staticRenderFns } from "./QuestionValue.vue?vue&type=template&id=0b9ba523&scoped=true"
import script from "./QuestionValue.vue?vue&type=script&lang=js"
export * from "./QuestionValue.vue?vue&type=script&lang=js"
import style0 from "./QuestionValue.vue?vue&type=style&index=0&id=0b9ba523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ba523",
  null
  
)

export default component.exports